import Api from "../../../Api";

export const getEntertainmentRevenueCenterMenu = async () => {
  try {
    let res = await Api.get("/backoffice/entertainment/revenue-center-menu");
    return res?.data?.menus || [];
  } catch (e) {
    return [];
  }
};

export const getEntertainmentRvcs = async (query) => {
  try {
    let res = await Api.get("/backoffice/entertainment/rvc", { params: query });
    return res?.data || { data: [], totalCount: 0 };
  } catch (e) {
    return { error: e?.response?.data?.message || "Something Wrong" };
  }
};

export const getEntertainmentRvc = async (id) => {
  try {
    let res = await Api.get("/backoffice/entertainment/rvc/" + id);
    return res?.data || {};
  } catch (e) {
    return { error: e?.response?.data?.message || "Something Wrong" };
  }
};

export const createEntertainmentRvc = async (data) => {
  try {
    let res = await Api.post("/backoffice/entertainment/rvc", data);
    return res?.data || {};
  } catch (e) {
    return { error: e?.response?.data?.message || "Something Wrong" };
  }
};

export const updateEntertainmentRvc = async (id, data) => {
  try {
    let res = await Api.patch("/backoffice/entertainment/rvc/" + id, data);
    return res?.data || {};
  } catch (e) {
    return { error: e?.response?.data?.message || "Something Wrong" };
  }
};

export const deleteEntertainmentRvc = async (id) => {
  try {
    let res = await Api.delete("/backoffice/entertainment/rvc/" + id);
    return res?.data || {};
  } catch (e) {
    return { error: e?.response?.data?.message || "Something Wrong" };
  }
};

// ── Itemizer ─────────────────────────────────────────────────────────────

export const getEntertainmentItemizers = async (query) => {
  try {
    let res = await Api.get("/backoffice/entertainment/itemizer", { params: query });
    return res?.data || { data: [], totalCount: 0 };
  } catch (e) {
    return { error: e?.response?.data?.message || "Something Wrong" };
  }
};

export const getEntertainmentItemizer = async (id) => {
  try {
    let res = await Api.get("/backoffice/entertainment/itemizer/" + id);
    return res?.data || {};
  } catch (e) {
    return { error: e?.response?.data?.message || "Something Wrong" };
  }
};

export const createEntertainmentItemizer = async (data) => {
  try {
    let res = await Api.post("/backoffice/entertainment/itemizer", data);
    return res?.data || {};
  } catch (e) {
    return { error: e?.response?.data?.message || "Something Wrong" };
  }
};

export const updateEntertainmentItemizer = async (id, data) => {
  try {
    let res = await Api.patch("/backoffice/entertainment/itemizer/" + id, data);
    return res?.data || {};
  } catch (e) {
    return { error: e?.response?.data?.message || "Something Wrong" };
  }
};

export const deleteEntertainmentItemizer = async (id) => {
  try {
    let res = await Api.delete("/backoffice/entertainment/itemizer/" + id);
    return res?.data || {};
  } catch (e) {
    return { error: e?.response?.data?.message || "Something Wrong" };
  }
};

// ── Menu Item ────────────────────────────────────────────────────────────

export const getEntertainmentMenuItems = async (query) => {
  try {
    let res = await Api.get("/backoffice/entertainment/menu-items", { params: query });
    return res?.data || { data: [], totalCount: 0 };
  } catch (e) {
    return { error: e?.response?.data?.message || "Something Wrong" };
  }
};

export const getEntertainmentMenuItem = async (id) => {
  try {
    let res = await Api.get("/backoffice/entertainment/menu-items/" + id);
    return res?.data || {};
  } catch (e) {
    return { error: e?.response?.data?.message || "Something Wrong" };
  }
};

export const createEntertainmentMenuItem = async (data) => {
  try {
    let res = await Api.post("/backoffice/entertainment/menu-items", data);
    return res?.data || {};
  } catch (e) {
    return { error: e?.response?.data?.message || "Something Wrong" };
  }
};

export const updateEntertainmentMenuItem = async (id, data) => {
  try {
    let res = await Api.patch("/backoffice/entertainment/menu-items/" + id, data);
    return res?.data || {};
  } catch (e) {
    return { error: e?.response?.data?.message || "Something Wrong" };
  }
};

export const deleteEntertainmentMenuItem = async (id) => {
  try {
    let res = await Api.delete("/backoffice/entertainment/menu-items/" + id);
    return res?.data || {};
  } catch (e) {
    return { error: e?.response?.data?.message || "Something Wrong" };
  }
};

// ── Reports ──────────────────────────────────────────────────────────────

export const getEntertainmentSalesReport = async (query) => {
  try {
    let res = await Api.get("/backoffice/entertainment/report/sales", { params: query });
    return res?.data || { data: [], totalCount: 0 };
  } catch (e) {
    return { error: e?.response?.data?.message || "Something Wrong" };
  }
};

export const getEntertainmentTransaction = async (id) => {
  try {
    let res = await Api.get("/backoffice/entertainment/report/transactions/" + id);
    return res?.data || {};
  } catch (e) {
    return { error: e?.response?.data?.message || "Something Wrong" };
  }
};

export const getEntertainmentVoidReasons = async () => {
  try {
    let res = await Api.get("/backoffice/entertainment/report/void-reasons");
    return res?.data || [];
  } catch (e) {
    return [];
  }
};

export const getEntertainmentCurrentBusinessDate = async () => {
  try {
    let res = await Api.get("/backoffice/entertainment/report/current-business-date");
    return res?.data || {};
  } catch (e) {
    return {};
  }
};

export const getEntertainmentSummaryReport = async (query) => {
  try {
    let res = await Api.get("/backoffice/entertainment/report/summary", { params: query });
    return res?.data || { data: [], totalCount: 0 };
  } catch (e) {
    return { error: e?.response?.data?.message || "Something Wrong" };
  }
};

export const updateEntertainmentTransactionStatus = async (id, status, reason) => {
  try {
    let res = await Api.patch(`/backoffice/entertainment/report/transactions/${id}/status`, {
      status,
      ...(reason ? { reason } : {}),
    });
    return res?.data || {};
  } catch (e) {
    return { error: e?.response?.data?.message || "Something Wrong" };
  }
};
